import { QUERY_KEY_ENTITY, QUERY_KEY_TYPE } from '../../constants';
import { baseApi } from './base.api';

const LIST_TAG = `${QUERY_KEY_ENTITY.ENDPOINT}_${QUERY_KEY_TYPE.LIST}`;
const DROP_TAG = `${QUERY_KEY_ENTITY.ENDPOINT}_${QUERY_KEY_TYPE.DROPDOWN}`;

const endpointApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getEndpointsDropdown: build.query({
      query: () => `/v1/reports/endpoint-list`,
      providesTags: [{ type: DROP_TAG }],
      transformResponse: (data) =>
        data?.length
          ? data
              .map((item) => ({
                ...item,
                value: item.id,
                label: `(${item.id}) ${item.name}`,
              }))
              .sort((a, b) => b.value - a.value)
          : [],
    }),
    getEndpointsList: build.query({
      query: (filters) => ({
        url: `/v1/publisher/endpoints`,
        method: 'POST',
        body: { filters },
      }),
      providesTags: [{ type: LIST_TAG }],
    }),
    getEndpointById: build.query({
      query: (arg) => `/v1/publisher/endpoint/${arg}`,
      providesTags: (res, err, arg) => [
        { type: QUERY_KEY_ENTITY.ENDPOINT, id: Number(arg) || 0 },
      ],
    }),
    updateEndpointStatus: build.mutation({
      query: (arg) => ({
        url: '/v1/publisher/endpoint/update-status',
        method: 'POST',
        body: arg,
      }),
      invalidatesTags: (res, err, arg) =>
        err
          ? []
          : [
              { type: LIST_TAG },
              { type: DROP_TAG },
              ...arg.ids.map((id) => ({
                type: QUERY_KEY_ENTITY.ENDPOINT,
                id: Number(id) || 0,
              })),
            ],
    }),
    updateEndpoint: build.mutation({
      query: (arg) => ({
        url: arg.id
          ? `/v1/publisher/endpoint/update/${arg.id}`
          : '/v1/publisher/endpoint/add',
        method: 'POST',
        body: arg,
      }),
      invalidatesTags: (res, err, arg) =>
        err
          ? []
          : [
              { type: LIST_TAG },
              { type: DROP_TAG },
              { type: QUERY_KEY_ENTITY.WL },
              { type: QUERY_KEY_ENTITY.PUBLISHER },
              ...(arg.id
                ? [{ type: QUERY_KEY_ENTITY.ENDPOINT, id: Number(arg.id) || 0 }]
                : []),
            ],
    }),
    catchTrafficRequest: build.mutation({
      query: (id) => `/v1/publisher/endpoint/catch-req/${id}`,
    }),
    catchTrafficResponse: build.mutation({
      query: (id) => `/v1/publisher/endpoint/catch-resp/${id}`,
    }),
  }),
});

export const {
  useGetEndpointsDropdownQuery,
  useGetEndpointsListQuery,
  useGetEndpointByIdQuery,
  useUpdateEndpointStatusMutation,
  useUpdateEndpointMutation,
  useCatchTrafficRequestMutation,
  useCatchTrafficResponseMutation,
} = endpointApi;
